/*
  Artiley 2026-10-28: varukorgslådan, sedan 2026-11-02 på alla sidor (snippets/artiley-varukorg.liquid i
  snippets/cart-drawer.liquid). Lägger in säker betalning med loggor under kassaknappen och erbjuder ram till tavlor som saknar
  ram. Ramen läggs till exakt som ramväljaren gör (assets/frame-picker.js): en egen rad med
  _canvas_companion_variant (tavlans variant-id) och _canvas_companion_label ("<Motiv> <storlek>"), som
  tryckeriet läser för att veta vilken duk som ska i vilken ram. Lådan ritas om av temat vid varje ändring,
  så tilläggen görs om när innehållet byts (MutationObserver).
*/
(function () {
  if (window.__artileyVarukorg) return;
  window.__artileyVarukorg = true;
  var dataEl = document.getElementById('artiley-varukorg-data');
  var betalMall = document.getElementById('artiley-varukorg-betal');
  if (!dataEl || !document.getElementById('Cart-Drawer')) return;
  var D = JSON.parse(dataEl.textContent);

  var KOMPATIBLA = ['50x50', '50x70', '70x50', '70x100', '100x70', '80x80', '90x130', '130x90', '100x100'];
  // Samma ram oavsett orientering, som FRAME_KEY_ALIASES i frame-picker.js.
  var ALIAS = { '100x70': '70x100', '130x90': '90x130', '70x50': '50x70' };
  var RAMAR = { 'ram-ljus-ek': 'ljus-ek', 'ram-valnot': 'valnot' };
  var FARGER = ['ljus-ek', 'valnot'];
  var rot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // På produktsidorna är roten ibland "/sv" utan snedstreck, och då blev adressen "/svproducts/…".
  if (rot.slice(-1) !== '/') rot += '/';

  function storlek(raw) {
    return String(raw || '').toLowerCase().replace(/\s|cm/g, '').replace('×', 'x');
  }

  function tusental(s, sep) {
    var p = s.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return p.join('.');
  }
  function lokalt(major, dec) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(major);
    } catch (e) {
      return major.toFixed(dec);
    }
  }
  // Samma tolkning av butikens money_format som ramväljaren (formatShopifyMoney i frame-picker.js).
  function pengar(cents) {
    var fmt = window.__frameMoneyFormat || D.pengaformat || '';
    var m = cents / 100;
    function byt(namn, v) { return fmt.replace(new RegExp('\\{\\{\\s*' + namn + '\\s*\\}\\}', 'g'), v); }
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) return byt('amount_no_decimals_with_comma_separator', tusental(m.toFixed(0), '.'));
    if (fmt.indexOf('amount_no_decimals_with_space_separator') !== -1) return byt('amount_no_decimals_with_space_separator', tusental(m.toFixed(0), ' '));
    if (fmt.indexOf('amount_with_comma_separator') !== -1) return byt('amount_with_comma_separator', tusental(m.toFixed(2), '.').replace(/\.(\d{2})$/, ',$1'));
    if (fmt.indexOf('amount_with_space_separator') !== -1) return byt('amount_with_space_separator', tusental(m.toFixed(2), ' '));
    if (fmt.indexOf('amount_no_decimals') !== -1) return byt('amount_no_decimals', lokalt(m, 0));
    if (fmt.indexOf('amount') !== -1) return byt('amount', lokalt(m, 2));
    return lokalt(m, 0);
  }

  // Ramvarianterna: ramväljarens window.__frameVariants (marknadspriser uppdateras av frame-picker.js),
  // annars ramprodukternas JSON.
  var hamtade = null;
  function ramar() {
    if (window.__frameVariants && window.__frameVariants['ljus-ek']) return Promise.resolve(window.__frameVariants);
    if (hamtade) return Promise.resolve(hamtade);
    var handles = Object.keys(RAMAR);
    return Promise.all(handles.map(function (h) {
      return fetch(rot + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; });
    })).then(function (prods) {
      var ut = {};
      prods.forEach(function (p, i) {
        var farg = RAMAR[handles[i]];
        ut[farg] = {};
        ((p && p.variants) || []).forEach(function (v) {
          ut[farg][storlek(v.option1)] = { id: v.id, price: v.price, available: v.available };
        });
      });
      hamtade = ut;
      return ut;
    });
  }

  function korgen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function radensStorlek(item) {
    var o = item.options_with_values && item.options_with_values[0];
    return storlek(o ? o.value : item.variant_title);
  }

  // Tavlor i ramstorlek utan egen ramrad.
  function utanRam(korg) {
    var medRam = {};
    korg.items.forEach(function (i) {
      var v = i.properties && i.properties._canvas_companion_variant;
      if (v) medRam[String(v)] = true;
    });
    return korg.items.filter(function (i) {
      return !RAMAR[i.handle] && !medRam[String(i.variant_id)] && KOMPATIBLA.indexOf(radensStorlek(i)) !== -1;
    });
  }

  // Ramfärgerna i tavlans storlek, eller null när ingen av dem finns i lager.
  function ramval(item, data) {
    var s = radensStorlek(item);
    var nyckel = ALIAS[s] || s;
    var val = FARGER.map(function (f) { return { farg: f, v: data[f] && data[f][nyckel] }; }).filter(function (x) { return x.v; });
    if (!val.some(function (x) { return x.v.available; })) return null;
    return { item: item, s: s, val: val };
  }

  function stycke(namn, text) {
    var el = document.createElement('p');
    el.className = 'artiley-ramerbjudande__' + namn;
    if (namn === 'fel') el.hidden = true;
    if (text) el.textContent = text;
    return el;
  }

  function ramknappar(t, kort, rad) {
    var el = document.createElement('div');
    el.className = 'artiley-ramerbjudande__val';
    t.val.forEach(function (x) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'artiley-ramerbjudande__knapp';
      b.disabled = !x.v.available;
      b.setAttribute('data-tillganglig', x.v.available ? '1' : '0');
      b.innerHTML = '<img alt="" width="28" height="28"><span class="artiley-ramerbjudande__info">' +
        '<span class="artiley-ramerbjudande__namn"></span><span class="artiley-ramerbjudande__pris"></span></span>';
      b.querySelector('img').src = D.bilder[x.farg];
      b.querySelector('.artiley-ramerbjudande__namn').textContent = D.t[x.farg];
      b.querySelector('.artiley-ramerbjudande__pris').textContent = x.v.available ? '+ ' + pengar(x.v.price) : D.t.slut;
      b.addEventListener('click', function () { laggTill(t.item, t.s, x.v, b, kort, rad); });
      el.appendChild(b);
    });
    return el;
  }

  // Hårt mellanslag före "cm", så att måttet inte bryts från enheten i smala lådor.
  function tavlan(t) {
    return t.item.product_title + ', ' + t.s.replace('x', '×') + '\u00a0cm';
  }

  // En tavla: rubrik, tavlans namn, text och ramfärger. Flera tavlor (Fredrik 4/11: två likadana erbjudanden
  // på varandra var "kaka på kaka", och det syntes inte att det var två): ett erbjudande med rubrik och text
  // en gång och en rad per tavla med tavlans bild och namn. Högst två tavlor, så att lådan inte fylls.
  function erbjudande(tavlor) {
    var kort = document.createElement('div');
    kort.className = 'artiley-ramerbjudande';
    if (tavlor.length === 1) {
      kort.appendChild(stycke('rubrik', D.t.rubrik));
      kort.appendChild(stycke('tavla', tavlan(tavlor[0])));
      kort.appendChild(stycke('text', D.t.text));
      kort.appendChild(ramknappar(tavlor[0], kort, kort));
      kort.appendChild(stycke('fel'));
      return kort;
    }
    kort.className += ' artiley-ramerbjudande--flera';
    kort.appendChild(stycke('rubrik', D.t.rubrikFlera));
    kort.appendChild(stycke('text', D.t.textFlera));
    tavlor.forEach(function (t) {
      var rad = document.createElement('div');
      rad.className = 'artiley-ramerbjudande__rad';
      var namn = stycke('tavla');
      var bild = t.item.image;
      if (bild) {
        var img = document.createElement('img');
        img.alt = '';
        img.width = 32;
        img.height = 32;
        img.src = bild + (bild.indexOf('?') === -1 ? '?' : '&') + 'width=96';
        namn.appendChild(img);
      }
      var text = document.createElement('span');
      text.textContent = tavlan(t);
      namn.appendChild(text);
      rad.appendChild(namn);
      rad.appendChild(ramknappar(t, kort, rad));
      rad.appendChild(stycke('fel'));
      kort.appendChild(rad);
    });
    return kort;
  }

  // Alla knappar i erbjudandet låses medan ramen läggs till, felet visas vid tavlans rad.
  function laggTill(item, s, variant, knapp, kort, rad) {
    var knappar = kort.querySelectorAll('button');
    knappar.forEach(function (b) { b.disabled = true; });
    knapp.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variant.id,
          quantity: item.quantity,
          properties: {
            '_canvas_companion_variant': String(item.variant_id),
            '_canvas_companion_label': item.product_title + ' ' + s
          }
        }],
        sections: ['main-cart', 'cart-drawer', 'cart-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.text().then(function (t) { if (!r.ok) throw new Error('HTTP ' + r.status + ': ' + t); return JSON.parse(t); });
    }).then(function (state) {
      // Samma omritning av lådan som ramväljaren använder (Habitats <product-form>). Sidor utan formulär
      // (kollektioner, startsidan) ritar om lådan och korgikonen som temats snabbköp gör (app.js, product-card).
      var form = document.querySelector('product-form');
      if (form && typeof form.renderContents === 'function') { form.renderContents(state); return; }
      if (!state.sections || !state.sections['cart-drawer']) { window.location.href = rot + 'cart'; return; }
      [['Cart-Drawer', 'cart-drawer', '.cart-drawer'], ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']].forEach(function (s) {
        var el = document.getElementById(s[0]);
        var html = state.sections[s[1]];
        if (!el || !html) return;
        var ny = new DOMParser().parseFromString(html, 'text/html').querySelector(s[2]);
        if (ny) (el.querySelector(s[2]) || el).innerHTML = ny.innerHTML;
      });
      if (typeof CartDrawer !== 'undefined') new CartDrawer();
    }).catch(function (e) {
      console.error('[artiley-varukorg] ramen kunde inte läggas till', e);
      var fel = rad.querySelector('.artiley-ramerbjudande__fel');
      fel.textContent = D.t.fel;
      fel.hidden = false;
      knappar.forEach(function (b) { b.disabled = b.getAttribute('data-tillganglig') !== '1'; });
      knapp.classList.remove('is-loading');
    });
  }

  var senast = null;
  function forbattra() {
    var lada = document.getElementById('Cart-Drawer');
    if (!lada) return;
    var knappar = lada.querySelector('.cart-drawer-buttons');
    if (knappar && betalMall && !lada.querySelector('.artiley-varukorg__betal')) {
      knappar.insertAdjacentHTML('afterend', betalMall.innerHTML);
    }
    var lista = lada.querySelector('.product-cart-item--container');
    var nyckel = Array.prototype.map.call(lada.querySelectorAll('quantity-selector[data-id]'), function (q) {
      var input = q.querySelector('input');
      return q.getAttribute('data-id') + ':' + (input ? input.value : '');
    }).join('|');
    var harBlock = !!lada.querySelector('.artiley-ramerbjudande');
    if (senast && senast.nyckel === nyckel && senast.harBlock === harBlock) return;
    senast = { nyckel: nyckel, harBlock: harBlock };
    if (!lista) return;
    Promise.all([korgen(), ramar()]).then(function (res) {
      var mal = lada.querySelector('.product-cart-item--container');
      if (!mal) return;
      lada.querySelectorAll('.artiley-ramerbjudande').forEach(function (b) { b.remove(); });
      var tavlor = utanRam(res[0]).map(function (i) { return ramval(i, res[1]); }).filter(Boolean).slice(0, 2);
      if (tavlor.length) mal.insertAdjacentElement('afterend', erbjudande(tavlor));
      senast = { nyckel: nyckel, harBlock: tavlor.length > 0 };
    }).catch(function (e) { console.error('[artiley-varukorg]', e); });
  }

  var timer = null;
  function snart() { clearTimeout(timer); timer = setTimeout(forbattra, 60); }
  var lada = document.getElementById('Cart-Drawer');
  // Temat byter innehållet i #Cart-Drawer vid varje ändring (innerHTML), elementet självt står kvar.
  new MutationObserver(snart).observe(lada, { childList: true, subtree: true });
  snart();
})();
